/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Requirements_MissingInputs */

const en_case_requirements_missing = /** @type {(inputs: Case_Requirements_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const pt_br2_case_requirements_missing = /** @type {(inputs: Case_Requirements_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendente`)
};

/**
* | output |
* | --- |
* | "Missing" |
*
* @param {Case_Requirements_MissingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_requirements_missing = /** @type {((inputs?: Case_Requirements_MissingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Requirements_MissingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_requirements_missing(inputs)
	return pt_br2_case_requirements_missing(inputs)
});